export default __webpack_public_path__ + "static/profile_iwakuma-48e93bb14d8b815b1cb73e02adeb73e9.png";